<div id="top" class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Payer ma facture</div>
</div>

@if (brand !== 'coriolis') {
    <div class="w-100">
        <div class="row w-100 pt-3">
            <div>Vous nous devez <strong>{{ amount }}€</strong>.</div>
            <div>Afin d'éviter la facturation de pénalités de retard, voire la suspension de votre ligne, nous vous
                invitons à régler cette somme par carte bancaire en remplissant le formulaire sécurisé ci-dessous.
            </div>
            <div class="mt-3">L'équipe {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }}</div>
        </div>
        <div class="pt-3">
            @if (paymentDetailsInterface.amount) {
                <app-payment-form [paymentDetailsInterface]="paymentDetailsInterface"></app-payment-form>
            }
        </div>
    </div>
}

@if (brand == 'coriolis') {
    <div>
        @if (step == 1 && ledgerBills.length > 0) {
            <div>
                <div class="bold-label-text">Choisissez la facture</div>
                <div class="align-items-start mt-3 bills-list">
                    @for (ledger of ledgerBills; track ledger; let index = $index) {
                        <div class="item">
                            <input
                                    type="checkbox"
                                    class=""
                                    [value]="ledger.billId"
                                    [checked]="isChecked(ledger.billId)"
                                    [id]="'bill' + index "
                                    (change)="updateTotal($event, ledger)"
                            />
                            <label [for]="'bill' + index " class="form-check-label">{{ ledger.customerId }}
                                - {{ ledger.billId }} - {{ ledger.period }} - {{ ledger.amount }}€</label>
                        </div>
                    }
                </div>
            </div>
        }
        <div class="row w-100">
            <div class="row w-100">
                <div>Montant à payer <strong>{{ total.toFixed(2) }}€</strong>.</div>
                <div>Afin d'éviter la facturation de pénalités de retard, voire la suspension de votre ligne, nous vous
                    invitons à régler cette somme par carte bancaire en remplissant le formulaire sécurisé ci-dessous.
                </div>
                <div class="mt-3">L'équipe {{ brand | titlecase }}</div>
            </div>
            @if (totalBillsDataLength > 500) {
                <div class="row w-100 error-message"> Vous avez dépasser le nombre maximal des factures sélectionnées
                </div>
            }
        </div>
        @if (step == 1) {
            <div class="row w-100 pt-3 text-center">
                <div class="col-12 w-100 cta_container">
                    <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                    @if (totalBillsDataLength <= 500 && ledgerBills.length > 0) {
                        <button type="button" class="cta_btn level_2 column" (click)="setStep(2)">Suivant<span></span>
                        </button>
                    }
                </div>
            </div>
        }
        @if (step == 2) {
            <div>
                <div class="pt-3">
                    <app-payment-form [paymentDetailsInterface]="paymentDetailsInterface"></app-payment-form>
                </div>
                <div class="row w-100 pt-3 text-center">
                    <div class="col-12 w-100 cta_container">
                        <button type="button" class="cta_btn level_2 column" (click)="setStep(1)">Retour<span></span>
                        </button>
                    </div>
                </div>
            </div>
        }
    </div>
}
